import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import * as _moment from "moment";

import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AgenciaService } from "src/app/servicios/agencia.service";
import { UsuarioService } from "src/app/servicios/usuario.service";
import { Observable } from "rxjs";
import { startWith, map } from "rxjs/operators";

export interface Usuario {
  id: string;
  valor: string;
}

export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY-MM-DD",
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: "YYYY-MM-DD",
    dateA11yLabel: "YYYY-MM-DD",
    monthYearA11yLabel: "YYYY-MM-DD",
  },
};

@Component({
  selector: "app-filtro-agencia-usuario-distribuidora-fecha",
  templateUrl: "./filtro-agencia-usuario-distribuidora-fecha.component.html",
  styleUrls: ["./filtro-agencia-usuario-distribuidora-fecha.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class FiltroAgenciaUsuarioDistribuidoraFechaComponent implements OnInit {
  @Output()
  propagar = new EventEmitter<string>();

  @Input() infoFiltro: any;

  filtroGroup: FormGroup;
  loadingAgencias = false;
  loadingUsuarios = false;
  loadingDistribuidoras = false;
  loading = false;
  usuarioConsulta = "";
  filteredUsuarios: Observable<Usuario[]>;
  filteredDistribuidoras: Observable<Usuario[]>;
  agencias: any;
  usuarios: any;
  distribuidoras: any;

  constructor(
    private fb: FormBuilder,
    private servicioAgencia: AgenciaService,
    private serviceUsuario: UsuarioService
  ) {
    this.filtroGroup = this.fb.group({
      idAgencia: ["", Validators.required],
      usuarioCtrl: ["", Validators.required],
      fechaInicial: [new Date(), Validators.required],
      fechaFinal: [new Date(), Validators.required],
      distribuidoraCtrl: ["", Validators.required],
    });

    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    this.usuarioConsulta = infoUsuario[0].IdUsuario;
    this.cargaData();
  }

  ngOnInit() {}

  async cargaData() {
    //await Promise.all[()];

    let agenciasPr = this.cargarAgencias();
    let usuariosPr = this.cargarUsuarios(0); //usuarios transferencistas
    let distribuidoraPr = this.cargarUsuarios(99); //usuarios distribuidoras

    let agencias = await agenciasPr;
    let usuarios = await usuariosPr;
    let distribuidoras = await distribuidoraPr;

    let ejecucion = agencias + usuarios + distribuidoras;

    this.setValues();
  }

  async setValues() {
    console.log(this.infoFiltro);
    //console.log(this.usuarios);
    let nombreUsuario = "";
    let codigoUsuario = "";
    let nombreDistribuidora = "";
    let codigoDistribuidora = "";

    if (this.infoFiltro.usuario != 0) {
      this.usuarios.forEach((el) => {
        if (this.infoFiltro.usuario == el.id) {
          nombreUsuario = el.valor;
          codigoUsuario = el.id;
        }
      });

      if (nombreUsuario) {
        this.filtroGroup.controls["idAgencia"].setValue(
          this.infoFiltro.agencia
        );
        this.loadingAgencias = false;

        await this.cargarUsuariosAgencia(0);

        this.filtroGroup.controls["usuarioCtrl"].setValue({
          id: codigoUsuario,
          valor: nombreUsuario,
        });
      }
    } else if (this.infoFiltro.distribuidora != 0) {
      this.distribuidoras.forEach((el) => {
        if (this.infoFiltro.distribuidora == el.id) {
          nombreDistribuidora = el.valor;
          codigoDistribuidora = el.id;
        }
      });

      if (nombreDistribuidora) {
        this.filtroGroup.controls["idAgencia"].setValue(
          this.infoFiltro.agencia
        );
        this.loadingAgencias = false;

        await this.cargarUsuariosAgencia(99);

        this.filtroGroup.controls["distribuidoraCtrl"].setValue({
          id: codigoDistribuidora,
          valor: nombreDistribuidora,
        });
      }
    } else {
      this.filtroGroup.controls["idAgencia"].setValue(this.infoFiltro.agencia);
      this.loadingAgencias = false;

      await this.cargaUsuariosDistribuidoras();
    }

    this.filtroGroup.controls["fechaInicial"].setValue(
      this.infoFiltro.fechaInicial
    );

    //console.log(new Date(this.infoFiltro.fechaInicial));
    this.filtroGroup.controls["fechaFinal"].setValue(
      this.infoFiltro.fechaFinal
    );

    //console.log(nombreUsuario);
  }

  async cargaUsuariosDistribuidoras() {
    let usrAgenciaPr = this.cargarUsuariosAgencia(0);
    let usrAgenciaDistPr = this.cargarUsuariosAgencia(99);

    let usrAgencia = await usrAgenciaPr;
    let usrAgenciaDist = await usrAgenciaDistPr;

    let ejecucion = usrAgencia + usrAgenciaDist;
  }

  displayFn(usuario) {
    //console.log(JSON.stringify(usuario));
    return usuario ? usuario.valor : usuario;
  }

  displayFnDist(distribuidora) {
    //console.log(JSON.stringify(usuario));
    return distribuidora ? distribuidora.valor : distribuidora;
  }

  async cargarUsuarios(esDistribuidora) {
    let retorno = "";
    if (esDistribuidora == 0) {
      retorno = "1";
      this.loadingUsuarios = true;
      let usuarios = await this.serviceUsuario
        .getUsuariosPersonas(3, this.usuarioConsulta, 0, esDistribuidora) //3 para tipo usuario vendedor
        .toPromise();

      this.usuarios = usuarios;
      this.usuarios.unshift({
        id: "0",
        valor: "TODOS",
      });
      this.filtroGroup.controls["usuarioCtrl"].setValue({
        id: "0",
        valor: "TODOS",
      });
      this.loadingUsuarios = false;
      this.filteredUsuarios = this.filtroGroup
        .get("usuarioCtrl")
        .valueChanges.pipe(
          startWith(""),
          map((usuario) =>
            usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()
          )
        );
    } else if (esDistribuidora == 99) {
      retorno = "2";
      this.loadingDistribuidoras = true;
      let distribuidoras = await this.serviceUsuario
        .getUsuariosPersonas(3, this.usuarioConsulta, 0, esDistribuidora) //3 para tipo usuario vendedor
        .toPromise();

      this.distribuidoras = distribuidoras;
      this.distribuidoras.unshift({
        id: "0",
        valor: "TODOS",
      });
      this.filtroGroup.controls["distribuidoraCtrl"].setValue({
        id: "0",
        valor: "TODOS",
      });
      this.loadingDistribuidoras = false;
      this.filteredDistribuidoras = this.filtroGroup
        .get("distribuidoraCtrl")
        .valueChanges.pipe(
          startWith(""),
          map((distribuidora) =>
            distribuidora
              ? this._filterDistribuidoras(distribuidora)
              : this.distribuidoras.slice()
          )
        );
    }
    return Promise.resolve(retorno);
  }

  async cargarAgencias() {
    this.loadingAgencias = true;
    let agencias = await this.servicioAgencia
      .getAgencia(this.usuarioConsulta, 0)
      .toPromise();

    this.agencias = agencias;
    this.agencias.unshift({
      id: 0,
      valor: "TODOS",
    });
    this.filtroGroup.controls["idAgencia"].setValue("0");
    this.loadingAgencias = false;
    this.filtroGroup.get("idAgencia").valueChanges.subscribe((value) => {
      //this.cargarUsuariosAgencia(0);
      this.cargaUsuariosDistribuidoras();
    });

    return Promise.resolve("0");
  }

  async cargarUsuariosAgencia(esDistribuidora) {
    this.loadingUsuarios = true;
    const agencia = this.filtroGroup.get("idAgencia").value;

    let respuesta = await this.serviceUsuario
      .getUsuariosPersonas(3, this.usuarioConsulta, agencia, esDistribuidora) //3 es para usuarios tipo vendedor, el valor esDistribuidora cero "0" tranferencistra y 99 distribuidora
      .toPromise();

    if (esDistribuidora == 0) {
      this.usuarios = respuesta;
      this.usuarios.unshift({
        id: "0",
        valor: "TODOS",
      });
      this.filtroGroup.controls["usuarioCtrl"].setValue({
        id: "0",
        valor: "TODOS",
      });
      this.loadingUsuarios = false;
      this.filteredUsuarios = this.filtroGroup
        .get("usuarioCtrl")
        .valueChanges.pipe(
          startWith(""),
          map((usuario) =>
            usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()
          )
        );

      return Promise.resolve(0);
    } else {
      this.distribuidoras = respuesta;
      this.distribuidoras.unshift({
        id: "0",
        valor: "TODOS",
      });
      this.filtroGroup.controls["distribuidoraCtrl"].setValue({
        id: "0",
        valor: "TODOS",
      });
      this.loadingDistribuidoras = false;
      this.filteredDistribuidoras = this.filtroGroup
        .get("distribuidoraCtrl")
        .valueChanges.pipe(
          startWith(""),
          map((distribuidora) =>
            distribuidora
              ? this._filterDistribuidoras(distribuidora)
              : this.distribuidoras.slice()
          )
        );

      return Promise.resolve(1);
    }
  }

  private _filterUsuarios(value: any): Usuario[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    //console.log(filterValue);
    //const filterValue = value.valor.toLowerCase();

    return this.usuarios.filter(
      (usuario) => usuario.valor.toLowerCase().indexOf(filterValue) > -1
    );
  }

  private _filterDistribuidoras(value: any): Usuario[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    //console.log(filterValue);
    //const filterValue = value.valor.toLowerCase();

    return this.distribuidoras.filter(
      (distribuidora) =>
        distribuidora.valor.toLowerCase().indexOf(filterValue) > -1
    );
  }

  busqueda() {
    const usuarioConsulta = this.usuarioConsulta;
    const agencia = this.filtroGroup.get("idAgencia").value;
    const usuario = this.filtroGroup.get("usuarioCtrl").value;
    const fechaInicial = _moment(
      this.filtroGroup.get("fechaInicial").value,
      "YYYY-MM-DD"
    ).format("YYYY-MM-DD");
    const fechaFinal = _moment(
      this.filtroGroup.get("fechaFinal").value,
      "YYYY-MM-DD"
    ).format("YYYY-MM-DD");
    const distribuidora = this.filtroGroup.get("distribuidoraCtrl").value;
    //console.log(distribuidora);
    const params = {
      usuario: usuario.id,
      agencia: agencia,
      fechaInicial: fechaInicial,
      fechaFinal: fechaFinal,
      usuarioConsulta: usuarioConsulta,
      distribuidora: distribuidora.id,
    };

    this.propagar.emit(JSON.stringify(params));
  }
}

/*
ESTRUCTURA DE infoFiltro

{

    "usuario":0,
    "agencia":0,
    "fechaInicial":"Sun Aug 02 2020 14:43:58 GMT-0500 (hora estándar de Colombia)", // esto es igual a new Date()
    "fechaFinal":"Sun Aug 02 2020 14:43:58 GMT-0500 (hora estándar de Colombia)", // esto es igual a new Date()
    "usuarioConsulta":35 //se obtiene de JSON.parse(sessionStorage.getItem("infoUsuario")) y el item IdUsuario en la posicion cero del arreglo

}

*/
